// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"c-PersonalIdentityNumber__inputWrapper","input":"c-PersonalIdentityNumber__input"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/PersonalIdentityNumber/PersonalIdentityNumber.scss
// module id = 1117
// module chunks = 0